import moment from 'moment'
import config from '@/config'
import PropTypes from 'prop-types'
import lang from '@/lang'

const EMPTY_PROP = '-'
const DATE_FORMAT = config.dateFormat.client
const TIME_FORMAT = config.datetimeFormat.client

export const DateTimeAmountCell = (props) => {
  const { value } = props
  const formattedValue = value ? moment(value).format(`${DATE_FORMAT} ${TIME_FORMAT} ${lang.dateTimeFormatSuffix}`) : EMPTY_PROP
  return formattedValue
}

DateTimeAmountCell.propTypes = {
  value: PropTypes.any,
}

export default DateTimeAmountCell
